<template>
<bim-row id="early-access" class="services-lending__access-container" justify="center">
  <bim-col cols="12" sm="7">
    <p class="access__ready">Готовы шагнуть в будущее?</p>
    <h2 class="access__early-access">Будьте в первых рядах.  Ранний доступ уже открыт.</h2>
    <bim-button @click="$emit('showModal')" v-metric="'LENDING-SMPP_CLICK-ON-SEND-REQUEST'" class="get-access__button" size="l" label="Получить доступ"></bim-button>
    <p class="access__questions">есть вопросы?</p>
    <p class="access__consult">Проконсультируем бесплатно</p>
    <a class="access__phone" href="tel:88005002575">8 800 500-25-75</a>
  </bim-col>
</bim-row>
</template>

<script>
import bimRow from '@bimlib/components/bimRow'
import bimCol from '@bimlib/components/bimCol'

export default {
  name: "block-early-access",
  components: {
    bimCol,
    bimRow
  }
}
</script>